export const UPDATE_TOPICS_FETCH_KEY = 'state.ui.topics.UPDATE_TOPICS_FETCH_KEY';

export interface UpdateTopicsFetchKey {
	type: typeof UPDATE_TOPICS_FETCH_KEY;
}

export const updateTopicsFetchKey = (): UpdateTopicsFetchKey => ({
	type: UPDATE_TOPICS_FETCH_KEY,
});
